import $ from 'jquery'
import mapboxgl from 'mapbox-gl'

export default class Map {
    constructor() {
        if ($('.js-projects-map').length) {
            let active_filters = {}
            let selected_regions = []
            let all_locations = []
            const $filter_toggle = $('.js-projects-map .js-filters__toggle')
            const $filter_drawer = $('.js-projects-map .js-filters__drawer')
            const $region_filters = $('.js-map-region-filters')
            let first_load = true

            // Get Mapbox API key
            mapboxgl.accessToken = portman.mapbox_api_key

            const map = new mapboxgl.Map({
                center: [-98.5795, 39.8283],
                container: 'js-map',
                cooperativeGestures: true,
                projection: 'mercator',
                style: 'mapbox://styles/mapbox/dark-v11',
                zoom: 3,
            })

            window.portmanMap = map
            window.portmanMapRefreshBounds = () => {
                if (all_locations.length > 0) {
                    displayMarkers(all_locations)
                }
            }

            // Add zoom and rotation controls to the map
            map.addControl(new mapboxgl.NavigationControl())

            // Get all published projects via AJAX
            $.ajax({
                type: 'POST',
                url: portman.ajax_url,
                dataType: 'json',
                data: {
                    action: 'get_projects',
                },
                success: function (res) {
                    if (res.success) {
                        updateMarkers(res.data.locations, res.data.regions)
                    } else {
                        console.error(res.data)
                    }
                },
                error: function (xhr, status, error) {
                    console.error(error)
                },
            })

            $('body').on('click', '.js-projects-map__sidebar-close', function () {
                $(this).parent().removeClass('is-active')
            })

            $('body').on('click', '.js-projects-map .js-filters__toggle', function () {
                const $this = $(this)

                $this.toggleClass('is-active')
                $filter_drawer.toggleClass('is-active')
            })

            $('body').on('click', '.js-projects-map .js-filters__filter', function () {
                const $this = $(this)
                const taxonomy = $this.data('taxonomy')
                const termId = $this.data('term-id')

                // Initialize the taxonomy key in active_filters if it doesn't exist
                if (!active_filters[taxonomy]) {
                    active_filters[taxonomy] = []
                }

                // Check if filter is already active
                if ($this.hasClass('is-active')) {
                    const index = active_filters[taxonomy].indexOf(termId)

                    // Remove filter if active
                    $this.removeClass('is-active')

                    if (index !== -1) {
                        active_filters[taxonomy].splice(index, 1)
                    }
                } else {
                    // Add filter if not active
                    $this.addClass('is-active')

                    active_filters[taxonomy].push(termId)
                }
            })

            $('body').on('click', '.js-filters__submit', function () {
                // Run AJAX call to filter projects
                $.ajax({
                    type: 'POST',
                    url: portman.ajax_url,
                    dataType: 'json',
                    data: {
                        action: 'filter_items',
                        post_type: 'project',
                        map_filtering: true,
                        show_all: active_filters.length < 1 ? true : false,
                        active_filters,
                    },
                    success: function (res) {
                        const $filter_count = $('.js-filters__active-count')

                        updateMarkers(res.data.locations, res.data.regions)

                        // Update active filter count
                        if (active_filters.length > 0) {
                            $filter_count.text(`(${active_filters.length})`).show()
                        } else {
                            $filter_count.hide().text('')
                        }

                        // Hide filter drawer
                        $filter_toggle.removeClass('is-active')
                        $filter_drawer.removeClass('is-active')
                    },
                })
            })

            function renderRegionFilters(regions) {
                if (!$region_filters.length) return
                if (!regions || !regions.length) return

                let html =
                    '<button class="c-filters__filter-button js-map-region-filter is-active" data-region="all" type="button">All Locations</button>'
                regions.forEach((region) => {
                    html += `<button class="c-filters__filter-button js-map-region-filter" data-region="${region.code}" type="button">${region.name}</button>`
                })
                $region_filters.html(html)
            }

            $('body').on('click', '.js-map-region-filter', function () {
                const $this = $(this)
                const region = $this.data('region')

                $('.js-projects-map__sidebar').removeClass('is-active')

                if (region === 'all') {
                    selected_regions = []
                    $('.js-map-region-filter').removeClass('is-active')
                    $this.addClass('is-active')
                } else {
                    $(".js-map-region-filter[data-region='all']").removeClass('is-active')
                    if ($this.hasClass('is-active')) {
                        $this.removeClass('is-active')
                        selected_regions = selected_regions.filter((r) => r !== region)
                    } else {
                        $this.addClass('is-active')
                        selected_regions.push(region)
                    }
                    if (selected_regions.length === 0) {
                        $(".js-map-region-filter[data-region='all']").addClass('is-active')
                    }
                }

                displayMarkers(all_locations)
            })

            function removeMarkers(markers) {
                while (markers.length > 0) {
                    markers[0].parentNode.removeChild(markers[0])
                }
            }

            function displayMarkers(locations) {
                removeMarkers(document.getElementsByClassName('mapboxgl-marker'))

                const filtered =
                    selected_regions.length > 0
                        ? locations.filter((loc) => loc.region && selected_regions.includes(loc.region.code))
                        : locations

                if (filtered.length === 0) return

                const bounds = new mapboxgl.LngLatBounds()

                filtered.forEach(function (location) {
                    const popup = new mapboxgl.Popup({ offset: 25 }).setText(location.title)

                    const marker = new mapboxgl.Marker({ color: '#eb0029' })
                        .setLngLat([location.longitude, location.latitude])
                        .setPopup(popup)
                        .addTo(map)

                    bounds.extend([location.longitude, location.latitude])

                    marker.getElement().addEventListener('click', function () {
                        const $sidebar = $('.js-projects-map__sidebar')
                        const $sidebarTitle = $('.js-projects-map__sidebar-title')
                        const $sidebarImage = $('.js-projects-map__sidebar-image')
                        const $sidebarAddress = $('.js-projects-map__sidebar-address')
                        const $sidebarLink = $('.js-projects-map__sidebar-link')

                        $sidebarTitle.text(location.title)
                        $sidebarImage.html(location.image)
                        $sidebarAddress.html(location.address)
                        $sidebarLink.attr('href', location.permalink)

                        if (!$sidebar.hasClass('is-active')) {
                            setTimeout(() => {
                                $sidebar.toggleClass('is-active')
                            }, 300)
                        }
                    })
                })

                map.fitBounds(bounds, {
                    padding: 100,
                    maxZoom: 15,
                })
            }

            function updateMarkers(filteredData, regions) {
                all_locations = filteredData
                    .filter(function (project) {
                        return project.map &&
                               typeof project.map.lat === 'number' &&
                               typeof project.map.lng === 'number';
                    })
                    .map(function (project) {
                        return {
                            title: project.title,
                            image: project.image,
                            address: project.address,
                            permalink: project.permalink,
                            longitude: project.map.lng,
                            latitude: project.map.lat,
                            region: project.region,
                        }
                    })

                renderRegionFilters(regions)
                displayMarkers(all_locations)
            }
        }
    }
}
